<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="90%" v-model="stationFanceModal">
      <v-card v-if="stationFanceModal">
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-map</v-icon>
              <span class="modal-title-text mr-2">فنس</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12">
              <div id="fanceMap">
                <l-map v-if="isFenceMapReadyToShow" ref="fancemap" style="height:54vh !important" :zoom="fanceZoom"
                  :center="fanceCenter" :options="fanceMapOptions" @update:center="fanceCenterUpdate"
                  @update:zoom="fanceZoomUpdate" @ready="fanceMapInvalidate()">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <l-polygon ref="fancePolygon" :lat-lngs="polyganData.latlngs" v-if="stationHasFance"></l-polygon>
                </l-map>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-n3">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addStationFanceFunction()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <!-- <v-btn v-if="stationHasFance" color="red" @click="showRemoveFanceConfirmFunction()" dark rounded
            class="normal-letter-spacing px-12">
            حذف
          </v-btn> -->
          <v-btn rounded color="darkColor" outlined @click="closeStationFenceModal()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="عنوان" class="input-label"
                prepend-inner-icon="mdi-hospital-building mdi-18px" tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchCode" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="کد" class="input-label"
                prepend-inner-icon="mdi-hospital-building mdi-18px" tabindex="2"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهرستان"
                v-model="searchCityId" @change="searchCityChange()" autocomplete="off"
                prepend-inner-icon="mdi-home-city mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allZonesForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="ناحیه"
                v-model="searchZoneId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="900" v-model="showAddEditModal" persistent>
      <v-card v-if="showAddEditModal">
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="6">
              <v-text-field type="text" v-model="station.title" dense :autofocus="true" clearable hide-details
                clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="عنوان*" class="input-label" prepend-inner-icon="mdi-station-building mdi-18px"
                tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="station.code"
                hide-details @keypress="isNumber($event)" dense outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="کد پایگاه*" class="input-label" prepend-inner-icon="mdi-map-marker mdi-18px"
                tabindex="2"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="3" dense outlined
                hide-details clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                @change="getCityGeoLocation()" label="شهرستان*" v-model="cityId" autocomplete="off"
                prepend-inner-icon="mdi-home-city mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allZonesForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="4" dense outlined
                hide-details clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                label="ناحیه*" v-model="station.zoneId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allGeographicalTypes" no-data-text="اطلاعاتی وجود ندارد" tabindex="5" dense
                hide-details outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                label="نوع پایگاه*" v-model="station.geographicalTypeId" autocomplete="off"
                prepend-inner-icon="mdi-text mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <span>موقعیت</span>
            <v-divider class="mt-2 mr-3"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12">
              {{ url }}
              <div id="map">
                <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 44vh !important" @click="addMarker"
                  :zoom="zoom" :center="center" :options="mapOptions" @update:center="centerUpdate"
                  @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                  <!-- Marker -->
                  <l-marker v-if="position && position.lat && position.lng" visible draggable :icon="icon"
                    :lat-lng.sync="position" @dragstart="dragging = true" @dragend="dragging = false"></l-marker>
                </l-map>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت پایگاه ها</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن پایگاه
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="stationManagmentInformationTableHeaders"
                          :items="stationFilteredList" :page.sync="page" :items-per-page="stationFilteredList.length"
                          height="62vh" :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="goToCoverage(item.id)" v-bind="attrs" v-on="on">
                                  mdi-layers
                                </v-icon>
                              </template>
                              <span>فنس منطقه</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showFanceModal(item.id)" v-bind="attrs" v-on="on">
                                  mdi-map
                                </v-icon>
                              </template>
                              <span>فنس پایگاه</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle v-model="page" :length="totalPages" :total-visible="8"
                      color="lightColor" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LPolygon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import PaginationComponent from '../../components/PaginationComponent.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import SharedMap from '@/Mixins/map';
import stationMixin from '@/Mixins/BaseInformation/StationMixin';
import cityMixin from '@/Mixins/BaseInformation/CityMixin';
import ServiceMixin from '@/Mixins/ServiceMixin';
import ProvinceMixin from '@/Mixins/BaseInformation/ProvinceMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import stationHelper from '@/Helpers/BaseInformation/StationHelper';
import StationFenceMixin from '@/Mixins/BaseInformation/StationFenceMixin.js';
import GeographicalTypeMixin from '@/Mixins/BaseInformation/GeographicalTypeMixin';
export default {
  name: 'StationManagment',
  title: 'پایگاه',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
  },
  mixins: [
    pagination,
    ShearedMixin,
    stationMixin,
    stationHelper,
    snackBar,
    cityMixin,
    ServiceMixin,
    ProvinceMixin,
    ShearedHelper,
    ZoneMixin,
    StationFenceMixin,
    GeographicalTypeMixin,
    SharedMap,
  ],
  created() {
    this.$root.$refs.StationManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      zoom: 12,
      // center: latLng(30.2839, 57.0834),
      mapTileUrl: '',
      attribution: '&copy; Asemantech',
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: null,
      dragging: false,
      icon: this.getIcon,
      //fance
      fanceMapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      fanceZoom: 13,
      // fanceCenter: [30.2839, 57.0834],
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfStationsWithPagination();
      this.getListOfCitysForOther();
      this.getListOfProvinces();
      this.getAllGeographicalTypes();
      this.setMapBaseSystemSetting();
      this.setFanceMapBaseSystemSetting();
    },
    previous: function () {
      this.getListOfStationsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfStationsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfStationsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    addMarker(event) {
      this.position = event.latlng;
    },
    //fance
    fanceCenterUpdate(center) {
      this.currentCenter = center;
    },
    fanceZoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    // fanceMapInvalidate: function () {
    //   setTimeout(() => {
    //     this.$refs.fancemap.mapObject.invalidateSize();
    //   }, 100);
    // },
    fanceMapInvalidate() {
      setTimeout(() => {
        const map = this.$refs.fancemap?.mapObject;
        if (!map) return;
        map.invalidateSize();

        map.on('pm:remove', (e) => {
          if (e.layer instanceof L.Polygon) {
            this.polyganData.latlngs = [];
            this.stationHasFance = false;
          }
        });

        map.on('pm:clear', () => {
          this.polyganData.latlngs = [];
          this.stationHasFance = false;
        });
      }, 100);
    },
  },
  watch: {
    'polyganData.latlngs': function (currentVal) {
      if (currentVal?.length) this.fenceCentering(currentVal);
    },
  },
  computed: {
    fanceCenter() {
      const lat = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLatitude;
      const lng = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLongitude;

      return lat && lng ? [lat, lng] : [30.2839, 57.0834];
    },
    stationFilteredList() {
      return this.stationPaginationList.filter((u) => {
        return u.title.includes(this.searchTitle);
      });
    },
    swatchStyle() {
      const { colorValue, menu } = this;
      return {
        backgroundColor: colorValue,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      };
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
